export default {
  advertOccupations: state => state.advertOccupations,
  advertTotalCount: state => state.advertTotalCount,

  getStatItemsBy: state => ({ type = 'advertisers', countyId, cityId, district } = {}) => {
    const items = state[type].find(item => {
      if (district) return item.district === district
      if (cityId) return item.cityId === cityId
      if (countyId) return item.countyId === countyId
      return false
    })

    if (items) {
      return items.data
    }

    return []
  },

  getCounty: state => countyId => state.statCounties.find(county => county.countyId === countyId),

  totalAdverts: state => state.advertisers.reduce((sum, location) => {
    sum += location.data.reduce((sum2, data) => {
      sum2 += data.advertCount
      return sum2
    }, 0)

    return sum
  }, 0),

  // eslint-disable-next-line no-return-assign
  totalAdvertisers: state => state.statCounties.reduce((sum, county) => sum += county.advertiserCount, 0) || 0,
  // eslint-disable-next-line no-return-assign
  totalAdWatches: state => state.statCounties.reduce((sum, county) => sum += county.adwatchCount, 0) || 0,
  // eslint-disable-next-line no-return-assign
  totalOffers: state => state.statCounties.reduce((sum, county) => sum += county.offerCount, 0) || 0,

  advertiserStats: state => state.advertiserStats.country,
  getAdvertiserStatsByCounty: state => countyId => {
    const county = state.advertiserStats.counties.find(county => county.countyId === countyId)
    if (county) {
      return county.data
    }

    return {
      ageGroups: {},
      locEntries: [],
      qualGroups: {}
    }
  },

  aggregatedAdWatches: state => state.aggregatedAdWatches,
  // Stats map
  statAdWatches: state => state.statAdWatches,

  employerSearchOccupations: state => state.employerSearchOccupations,
  statCounties: state => state.statCounties,
  topOccupations: state => state.topOccupations,
  weeklyBids: state => state.weeklyBids,
  workLocationStatistics: state => state.workLocations
}



// WEBPACK FOOTER //
// ./src/store/modules/stat/getters.js